import React from 'react'
import { Modal, Button } from 'antd';
import { translate } from 'react-i18next'

const ModalCancel = ({ modalCancel, hideCancelModal, onCancelReservation, t }) => {
    return (
        <Modal
            title={t("reservation_modal_cancel.header")}
            visible={modalCancel}
            onCancel={hideCancelModal}
            closable={false}
            className="modal-cancel"
            footer={<div>
                <Button onClick={onCancelReservation}>{t("reservation_modal_cancel.OK")}</Button>
                <Button onClick={hideCancelModal}>{t("reservation_modal_cancel.cancel")}</Button>
            </div>}
        >
            <p>{t("reservation_modal_cancel.detail")}</p>
        </Modal>
    )
}

export default translate()(ModalCancel)
